import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(10, 18),
    },
    gridContainer: {
      height: "calc(100vh - 102px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(60, 0, 135, 0),
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(5),
      borderRadius: "140px",
      backgroundColor: "#EFEDF6",
      marginBottom: theme.spacing(8),
    },
    icon: {
      width: "24px",
      height: "24px",
    },
    title: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "29px",
      color: "#130F3A",
      marginBottom: theme.spacing(4),
    },
    subtitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      color: theme.gray500,
      marginBottom: theme.spacing(12),
      textAlign: "center",
    },
    btnSection: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(12),
      marginBottom: theme.spacing(12),
    },
    sampleCsvBtn: {
      display: "flex",
      gap: theme.spacing(2.5),
    },
  }),
);
